export default __webpack_public_path__ + "static/media/esport-alliance.277f3ade.png";